import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";
import Accordion from "@material-ui/core/Accordion";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Button from "@material-ui/core/Button";
import Divider from "@material-ui/core/Divider";
import Paper from "@material-ui/core/Paper";
import CircularProgress from "@material-ui/core/CircularProgress";
import Grid from "@material-ui/core/Grid";
import swal from "sweetalert";
import { _get } from "../Api";
import GetCurrency from "../helper/GetCurrency";
import { useParams } from "react-router-dom";
import cloudStore from "../store/CloudStore";
import { parse } from "date-fns";
import TablePagination from "@material-ui/core/TablePagination";
import { TextField } from "@material-ui/core";
import AuthorizationWrapper from "../components/AuthorizationWrapper";
import { closeSpReceipt } from "../store/SpReceiptApi";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
  icon: {
    verticalAlign: "bottom",
    height: 20,
    width: 20,
  },
  details: {},
  column: {
    flexBasis: "20%",
  },
  helper: {
    borderLeft: `2px solid ${theme.palette.divider}`,
    padding: theme.spacing(1, 2),
  },
  link: {
    color: theme.palette.primary.main,
    textDecoration: "none",
    "&:hover": {
      textDecoration: "underline",
    },
  },
  hide: {
    [theme.breakpoints.down("sm")]: {
      visibility: "hidden",
    },
  },
  div: {
    borderLeft: "1px solid",
    paddingLeft: "20px",
    [theme.breakpoints.down("sm")]: {
      borderLeft: "none",
      paddingLeft: 0,
    },
  },
}));

const processData = (data, callback) => {
  callback(data);
};

const fetchData = (id, page, perPage, callback) => {
  _get("/nova/sp_merchant/" + id + "/sp_receipt?number_per_page=" + perPage + "&page=" + page)
    .then((res) => {
      processData(res.data, callback);
    })
    .catch((e) => {
      swal({
        title: "Oops!",
        text: "Something went wrong.",
        icon: "error",
      });
      callback(null, e);
    });
};

export default function InHouseOrders() {
  const classes = useStyles();
  const [loading, setLoading] = React.useState(true);
  const [spReceipts, setOrders] = React.useState([]);
  const [expandAll] = React.useState(false);
  const [page, setPage] = React.useState(0);
  const [newPage, setNewPage] = React.useState(0);
  const [perPage, setPerPage] = React.useState(localStorage.getItem("ordersPerPage") || 10);
  const [expanded, setExpanded] = React.useState([]);
  const spMerchantId = Number.parseInt(useParams().spMerchantId);
  const spMerchant = cloudStore.merchant.sp_merchants.find((spMerchant) => spMerchant.id === spMerchantId);

  if (!spMerchant) {
    return (
      <div align="center">
        <CircularProgress color="primary" />
      </div>
    );
  }

  if (loading) {
    fetchData(spMerchantId, page, perPage, (res, e) => {
      if (e) {
        localStorage.setItem("ordersPerPage", 10);
        setPerPage(10);
      } else {
        _get("/nova/sp_merchant/" + spMerchantId)
          .then((result) => {
            if (result.data.sp_qr_codes && result.data.sp_qr_codes[0]) {
              console.log("Setting webapplink");
              localStorage.setItem("webAppLink", result.data.sp_qr_codes[0].identifier);
            }
          })
          .catch((e) => {
            swal({
              title: "Oops!",
              text: "Something went wrong.",
              icon: "error",
            });
            console.log(e);
          });
        setLoading(false);
        setOrders(res);
      }
    });
  }

  const handleExpansion = (id) => {
    let arr = expanded;
    if (expanded.includes(id)) {
      let index = expanded.indexOf(id);
      arr.splice(index, 1);
      setExpanded([...arr]);
    } else {
      arr.push(id);
      setExpanded([...arr]);
    }
  };

  const handleExpandAll = () => {
    let arr = [];
    for (let i = 0; i < spReceipts.length; i++) {
      arr.push(i);
    }
    setExpanded([...arr]);
  };

  const handleCollapseAll = () => {
    setExpanded([]);
  };

  if (loading) {
    return (
      <div align="center">
        <CircularProgress color="primary" />
      </div>
    );
  }

  return (
    <div className={classes.root}>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        <Typography variant="h4">In House Orders - {cloudStore.merchant.name}</Typography>
        <div style={{ margin: "15px" }}>
          <Button onClick={handleExpandAll} style={{ marginRight: "5px" }} variant="outlined">
            Expand all
          </Button>
          <Button onClick={handleCollapseAll} variant="outlined">
            Collapse all
          </Button>
        </div>
      </div>
      <Divider style={{ marginBottom: "10px" }} />

      <div>
        {spReceipts.reduce((spReceipts, spReceipt, i) => {
          let rounds = 0;
          spReceipts.push(
            <div key={i} style={{ marginBottom: "10px" }}>
              <Accordion
                expanded={expanded.includes(i)}
                defaultExpanded={expandAll}
                variant="outlined"
                onChange={() => handleExpansion(i)}
              >
                <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1c-content" id="panel1c-header">
                  <Grid container direction="row" spacing={2}>
                    <Grid item lg={1}>
                      <Typography className={classes.heading} color="primary">
                        {spReceipt.table_id}
                        {/*- {spReceipt.id}*/}
                      </Typography>
                    </Grid>
                    <Grid item lg={2} md={2} sm={2} xs={2} className={classes.hide}>
                      <Typography className={classes.heading}>
                        {parse(spReceipt.created_at + "Z", "yyyy-MM-dd HH:mm:ssX", new Date()).toLocaleString()}
                      </Typography>
                      <Typography className={classes.heading}>
                        {parse(spReceipt.updated_at + "Z", "yyyy-MM-dd HH:mm:ssX", new Date()).toLocaleString()}
                      </Typography>
                    </Grid>
                    <Grid item lg={2} md={6} sm={6} xs={6}>
                      <Typography
                        className={classes.secondaryHeading}
                        style={{
                          color: spReceipt.status === "CLOSED" ? "grey" : "red",
                        }}
                      >
                        {spReceipt.status}
                      </Typography>
                    </Grid>
                    <Grid item lg={2} xs={1} className={classes.hide}>
                      <Typography className={clsx(classes.secondaryHeading, classes.hide)}>
                        {spReceipt.sp_ordergroups.reduce((count, spOrdergroup) => {
                          if (spOrdergroup?.ordergroup?.o_m_articles) {
                            spOrdergroup.ordergroup.o_m_articles.forEach((OMArticle) => {
                              count += OMArticle.amount;
                            });
                          }
                          return count;
                        }, 0)}{" "}
                        item(s)
                      </Typography>
                    </Grid>
                    <Grid item lg={2} xs={1} className={classes.hide}>
                      <Typography className={clsx(classes.secondaryHeading, classes.hide)}>
                        {GetCurrency()}{" "}
                        {(
                          (spReceipt.sp_ordergroups.reduce((amount, spOrdergroup) => {
                            if (spOrdergroup?.ordergroup?.o_m_articles) {
                              spOrdergroup.ordergroup.o_m_articles.forEach((OMArticle) => {
                                amount += OMArticle.total_cost;
                              });
                            }
                            return amount;
                          }, 0) +
                            spReceipt.tip_amount +
                            spReceipt.transaction_costs) /
                          100
                        ).toFixed(2)}
                      </Typography>
                    </Grid>
                  </Grid>
                </AccordionSummary>
                <AccordionDetails className={classes.details}>
                  <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
                    <AuthorizationWrapper
                      permission={"spReceipt.close"}
                      child={
                        <div>
                          <Button
                            variant={"outlined"}
                            color={"primary"}
                            onClick={() => {
                              closeSpReceipt(spReceipt.sp_merchant_id, spReceipt.id);
                            }}
                          >
                            CLOSE TABLE
                          </Button>
                        </div>
                      }
                    />

                    <Grid container spacing={3}>
                      <Grid item container lg={6} md={6} sm={12} xs={12}>
                        <div
                          className={classes.div}
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            width: "inherit",
                          }}
                        >
                          <div style={{ display: "flex", flexDirection: "row" }}>
                            <Typography style={{ flexBasis: "35%", fontWeight: "bold" }} variant="caption">
                              Naam
                            </Typography>
                            <Typography style={{ flexBasis: "25%", fontWeight: "bold" }} variant="caption">
                              Prijs per stuk
                            </Typography>
                            <Typography style={{ flexBasis: "16%", fontWeight: "bold" }} variant="caption">
                              Hoeveelheid
                            </Typography>
                            <Typography style={{ flexBasis: "25%", fontWeight: "bold" }} variant="caption">
                              Totaal
                            </Typography>
                          </div>
                          <Divider />
                          <br />
                          {spReceipt.sp_ordergroups.map((spOrdergroup, i) => {
                            if (spOrdergroup.sp_user_id > 0) {
                              rounds += 1;
                            }
                            return (
                              <div key={i}>
                                <div style={{ display: "flex", width: "100%", justifyContent: "space-between" }}>
                                  <Typography>
                                    {spOrdergroup.sp_user_id > 0 ? "Ronde " + rounds : "Handheld/POS"}
                                  </Typography>
                                  <Typography>
                                    {parse(
                                      spOrdergroup.created_at + "Z",
                                      "yyyy-MM-dd HH:mm:ssX",
                                      new Date()
                                    ).toLocaleString()}
                                  </Typography>
                                </div>
                                {/*<Typography>SpOrdergroupId: {spOrdergroup.id}</Typography>*/}
                                {/*<Typography>ordergroup: {spOrdergroup.ordergroup.id}</Typography>*/}
                                {/*<Typography>Printed: {spOrdergroup.ordergroup.number_of_prints}</Typography>*/}
                                {spOrdergroup.ordergroup?.o_m_articles?.map((OMArticle) => {
                                  return (
                                    <div key={OMArticle.id}>
                                      {/*{OMArticle.id}*/}
                                      {OMArticle.name === "Bezorgkosten" || OMArticle.name === "Betaalkosten" ? (
                                        <br />
                                      ) : null}
                                      <div
                                        style={{
                                          display: "flex",
                                          flexDirection: "row",
                                        }}
                                      >
                                        <Typography
                                          style={{ flexBasis: "35%", flowWrap: "wrap", wordBreak: "break-word" }}
                                          variant="caption"
                                        >
                                          {OMArticle.name}
                                          {OMArticle.amount_void !== 0
                                            ? "(" + OMArticle.amount_void + " geannuleerd)"
                                            : ""}{" "}
                                          {OMArticle.info?.remark}
                                        </Typography>
                                        <Typography style={{ flexBasis: "25%" }} variant="caption">
                                          {GetCurrency()} {(OMArticle.cost / 100).toFixed(2)}
                                        </Typography>
                                        <Typography style={{ flexBasis: "16%" }} variant="caption">
                                          {OMArticle.amount}
                                          {OMArticle.amount === "" ? "" : "x"}
                                        </Typography>
                                        <Typography style={{ flexBasis: "25%" }} variant="caption">
                                          {GetCurrency()}{" "}
                                          {OMArticle.amount === ""
                                            ? (OMArticle.cost / 100).toFixed(2)
                                            : (OMArticle.total_cost / 100).toFixed(2)}
                                        </Typography>
                                      </div>
                                      <div>
                                        {OMArticle.o_m_modifiergroups.map((OMModifiergroup) => {
                                          return OMModifiergroup.o_m_modifierarticles.map((OMModifierarticle) => {
                                            return (
                                              <div
                                                key={OMModifierarticle.id}
                                                style={{
                                                  display: "flex",
                                                  flexDirection: "row",
                                                  marginTop: "0px",
                                                }}
                                              >
                                                <Typography
                                                  style={{
                                                    flexBasis: "35%",
                                                    fontSize: "80%",
                                                    color: "grey",
                                                  }}
                                                  variant="caption"
                                                >
                                                  {" "}
                                                  > {OMModifierarticle.name}
                                                </Typography>
                                                <Typography
                                                  style={{
                                                    flexBasis: "25%",
                                                    fontSize: "80%",
                                                    color: "grey",
                                                  }}
                                                  variant="caption"
                                                >
                                                  {OMModifierarticle.price === 0
                                                    ? ""
                                                    : "+" +
                                                      GetCurrency() +
                                                      " " +
                                                      (OMModifierarticle.price / 100).toFixed(2)}
                                                </Typography>
                                                <Typography
                                                  style={{ flexBasis: "16%", color: "grey" }}
                                                  variant="caption"
                                                >
                                                  {OMModifierarticle.amount}
                                                  {OMModifierarticle.amount === "" ? "" : "x"}
                                                </Typography>
                                                <Typography
                                                  style={{ flexBasis: "25%", color: "grey" }}
                                                  variant="caption"
                                                >
                                                  {GetCurrency()}{" "}
                                                  {((OMModifierarticle.amount * OMModifierarticle.price) / 100).toFixed(
                                                    2
                                                  )}
                                                </Typography>
                                              </div>
                                            );
                                          });
                                        })}
                                      </div>
                                    </div>
                                  );
                                })}
                                <br />
                                <Divider />
                              </div>
                            );
                          })}
                          <Divider variant="fullWidth" />
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              justifyContent: "space-between",
                            }}
                          >
                            <Typography style={{ flexBasis: "75%" }}>Totaal</Typography>
                            <Typography style={{ flexBasis: "25%" }}>
                              {GetCurrency()}{" "}
                              {(
                                (spReceipt.sp_ordergroups.reduce((amount, spOrdergroup) => {
                                  if (spOrdergroup?.ordergroup?.o_m_articles) {
                                    spOrdergroup.ordergroup.o_m_articles.forEach((OMArticle) => {
                                      amount += OMArticle.total_cost;
                                    });
                                  }
                                  return amount;
                                }, 0) +
                                  spReceipt.tip_amount +
                                  spReceipt.transaction_costs) /
                                100
                              ).toFixed(2)}
                            </Typography>
                          </div>
                        </div>
                      </Grid>
                      <Grid item container lg={6} md={6} sm={12} xs={12} alignContent={"flex-start"}>
                        <Grid item xs={6}>
                          <Typography style={{ fontWeight: "bold" }} variant="caption">
                            Betaalmethode
                          </Typography>
                        </Grid>
                        <Grid item xs={6}>
                          <Typography style={{ fontWeight: "bold" }} variant="caption">
                            Bedrag
                          </Typography>
                        </Grid>
                        {spReceipt.transactions
                          .filter((transaction) => transaction.status === "SUCCEEDED")
                          .map((transaction) =>
                            transaction.turnover_transactions.map((turnoverTransaction) => (
                              <>
                                <Grid item xs={6}>
                                  <Typography>{turnoverTransaction.turnover_group}</Typography>
                                </Grid>
                                <Grid item xs={6}>
                                  <Typography>
                                    {GetCurrency()} {(turnoverTransaction.amount / 100).toFixed(2)}
                                  </Typography>
                                </Grid>
                              </>
                            ))
                          )}
                      </Grid>
                    </Grid>
                  </div>
                </AccordionDetails>
              </Accordion>
            </div>
          );
          return spReceipts;
        }, [])}
      </div>

      <div>
        <Paper variant="outlined" style={{ height: "4em" }}>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justify: "space-around",
            }}
          >
            <TablePagination
              count={99999999}
              onChangePage={(event, newPage) => {
                setPage(newPage);
                setNewPage(newPage);
                setLoading(true);
              }}
              onChangeRowsPerPage={(event) => {
                setPage(0);
                setNewPage(0);
                setPerPage(parseInt(event.target.value, 10));
                setLoading(true);
              }}
              page={page}
              rowsPerPage={perPage}
            />
            <TextField
              value={newPage + 1}
              type={"number"}
              label={"Page"}
              onChange={(e) => {
                setNewPage(parseInt(e.target.value, 10) - 1);
              }}
              onBlur={(e) => {
                if (newPage !== page) {
                  setPage(newPage);
                  setLoading(true);
                }
              }}
            />
          </div>
        </Paper>
      </div>
    </div>
  );
}
